<template>
    <div class="inner-wrapper">
        <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
            <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
            <ul>
                <li v-for="(v, k) in commonErrors" :key="k">
                    <p v-for="error in v" :key="error" class="text-sm">
                        {{ error }}
                    </p>
                </li>
            </ul>
        </div>
        <div class="alert alert-success" role="alert" v-if="successMessage">
            {{ successMessage }}
        </div>

        <router-view/>

        <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>

import { mapState, mapActions, mapGetters  } from 'vuex';
import axios from "axios";

export default {
    name: "AddOrder",
    created() {
        if(localStorage.getItem('token')){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        //this.setNewOrder(this.newOrder);
    },
    mounted() {
        this.getSettings();
    },
    data(){
        return {
            newOrder: {
                id: null,
                is_draft: 0,
                is_stocking: 0,
                stocking_terms: null,
                warehouses: [],
                customerWarehouses: [],
                billTo: [],
                customer_id: null,
                sales_rep_id: null,
                order_number: null,
                order_date: null,
                customer_terms: null,
                customer_po: null,
                eta: null,
                fob: null,
                notes: null,
                customer_notes: null,
                quotations: [],
                customer: {
                    quotations_after_sent_to_customer: []
                },
                products:[],
                selectedProducts: [],
            },
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomerLoading',
            'setNewOrder',
            'setSettings',
            'setLoading'
        ]),

        getSettings() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('global-setting.index'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        self.setSettings(data.data);

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);
                });
        },

    },
    watch: {

    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
        ])
    }
}
</script>

<style scoped>

</style>
